// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "section[data-v-0e5adfe9]{padding:1em}p[data-v-0e5adfe9]{font-size:var(--body)}h1[data-v-0e5adfe9]{color:var(--colour-dark-blue);font-size:1.25em}.resend[data-v-0e5adfe9]{flex:1 0 auto}.resend+footer[data-v-0e5adfe9]{flex-shrink:0}.button-wrapper[data-v-0e5adfe9]{text-align:right}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
